
// This file stores your Stripe configuration.

// --- MODE SWITCH ---
// Set to true to use Stripe's Test Mode (fake cards, no real charges).
// Set to false for live payments with real money.
// IMPORTANT: Ensure the "Secret Key" you set in the terminal matches this mode (sk_test_... vs sk_live_...)
export const IS_TEST_MODE = false; 

// --- PUBLISHABLE KEYS ---
// REPLACE WITH YOUR KEYS FROM STRIPE DASHBOARD -> DEVELOPERS -> API KEYS
export const STRIPE_PUBLISHABLE_KEY_LIVE = "pk_live_51Pbtf7RrxBNn9l75VCLjEQXZy3J7zXn9l75VCLjEQXZy3J7zX"; // Assuming existing key, please ensure this is correct
export const STRIPE_PUBLISHABLE_KEY_TEST = "pk_test_51Pbtf7RrxBNn9l75VCLjEQXZy3J7zXn9l75VCLjEQXZy3J7zX"; // Assuming existing key


// --- PRICE ID MAPPINGS ---
// These IDs come from creating Products in your Stripe Dashboard.
// 1. Go to Stripe Dashboard > Products.
// 2. Click the product (e.g. "1 Clue").
// 3. Add a NEW price of 0.30 GBP.
// 4. Copy the "API ID" for the NEW price (starts with 'price_...').
// 5. Paste it below replacing the placeholder.

// LIVE Price IDs (Used when IS_TEST_MODE = false)
const STRIPE_PRICE_IDS_LIVE = {
    'clue_1': 'price_1Sl9ZuFHyvh9GBiSjmijRnkg', // Confirmed 1 Clue ID
    'clue_5': 'price_1ShE1vFHyvh9GBiSQXILy6Fw',
    'clue_15': 'price_1ShE30FHyvh9GBiS2qUygNgN',
    'clue_30': 'price_1ShE41FHyvh9GBiSBu1kLMWI',
    'clue_50': 'price_1ShE5MFHyvh9GBiSuCEcxlOn',
    'credit_1': 'price_1ShE6MFHyvh9GBiSYKiQkxCV', // Updated from screenshot (1 AI Credit)
    'credit_5': 'price_1ShE7AFHyvh9GBiSwXHp81IW',
    'credit_15': 'price_1ShE7yFHyvh9GBiSo1EknEX1',
    'credit_30': 'price_1ShE8sFHyvh9GBiSMHvP1J3G',
    'credit_50': 'price_1ShEA1FHyvh9GBiS5jPV8E5H',
    'business_1': 'price_business_placeholder_live',
};

// TEST Price IDs (Used when IS_TEST_MODE = true)
const STRIPE_PRICE_IDS_TEST = {
    // PASTE YOUR TEST MODE PRICE IDs HERE
    'clue_1': 'price_1Pbtf7RrxBNn9l75jHh9JAZx', 
    'clue_5': 'price_1Pbtf7RrxBNn9l75lF3k4g5h', 
    'clue_15': 'price_1Pbtf7RrxBNn9l75aBcDeFgH',
    'clue_30': 'price_1Pbtf7RrxBNn9l75kLmNoPqR',
    'clue_50': 'price_1Pbtf7RrxBNn9l75sTuVwXyZ',
    'credit_1': 'price_1Pbtf7RrxBNn9l75aB2c1d0e',
    'credit_5': 'price_1Pbtf7RrxBNn9l75fG8hI9jK',
    'credit_15': 'price_1Pbtf7RrxBNn9l75lM4nO5pQ',
    'credit_30': 'price_1Pbtf7RrxBNn9l75rS8tU9vW',
    'credit_50': 'price_1Pbtf7RrxBNn9l75xY2zAbCd',
    'business_1': 'price_business_placeholder_test',
};

// --- DYNAMICALLY EXPORTED CONFIG ---
// The app will automatically use the correct keys and IDs based on IS_TEST_MODE.
export const STRIPE_PRICE_IDS = IS_TEST_MODE ? STRIPE_PRICE_IDS_TEST : STRIPE_PRICE_IDS_LIVE;
export const STRIPE_PUBLISHABLE_KEY = IS_TEST_MODE ? STRIPE_PUBLISHABLE_KEY_TEST : STRIPE_PUBLISHABLE_KEY_LIVE;
